import { Card } from 'react-bootstrap';
import CustomAvatar from '../Profile/CustomAvatar';
import { CardActionArea, CardContent, CardHeader, IconButton, Tooltip, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import React from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteNotification, Notification, NotificationType } from '../../shared/requests/notifications';
import { useDispatch } from 'react-redux';
import { openSnackbar } from '../AppSnackbar/snackbarSlice';
import dayjs from '../../utils/dayjs';

interface NotificationComponentProps {
  sender: any;
  notification: Notification;
  style: React.CSSProperties;
  index: number;
}

export default function NotificationComponent(props: Readonly<NotificationComponentProps>) {
  const { sender, notification, style, index } = props;
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const { mutate: deleteNotif } = useMutation({
    mutationFn: deleteNotification,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['notifications', 'notificationsPage'] });
      dispatch(openSnackbar({ message: `Notification deleted successfully`, severity: 'success' }));
    },
    onError: (error) => {
      console.log(error.message);
      dispatch(openSnackbar({ message: `Notification failed to be deleted`, severity: 'error' }));
    },
  });

  const handleDeleteNotificationButtonClick = () => {
    deleteNotif(notification._id);
  };

  const getNotificationTitle = (notification: { [key: string]: any }) => {
    switch (notification?.notificationType) {
      case NotificationType.TEAM_MEMBER_TAGGING:
        return `You have been tagged!`;
      default:
        return '';
    }
  };

  return (
    <Card
      id={`notifications-option-${index}`}
      style={{
        ...style,
        borderBottomColor: '#F5F5F5',
        border: '1px',
        borderBottomStyle: 'solid',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: '20px',
          left: '20px',
        }}
      >
        <CustomAvatar user={sender} />
      </div>

      <Tooltip title="Delete">
        <IconButton
          aria-label="settings"
          onClick={handleDeleteNotificationButtonClick}
          style={{
            position: 'absolute',
            top: '20px',
            right: '20px',
            zIndex: 100,
          }}
        >
          <DeleteIcon />
        </IconButton>
      </Tooltip>

      <CardActionArea
        href={notification.redirectTo}
        style={{
          margin: '0',
          width: '100%',
          height: '100%',
        }}
      >
        <CardHeader
          title={getNotificationTitle(notification)}
          subheader={dayjs(new Date(notification.date)).fromNow()}
        />
        <CardContent>
          <Typography variant="body2" color="text.secondary">
            {notification.content}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
